<template>
  <div
    v-if="currentUser && currentUser.admin"
    class="sticky top-16 z-40 bg-white border-b border-gray-100 shadow-sm w-full"
  >
    <div class="max-w-[1280px] mx-auto px-4 md:px-6 py-3 flex justify-end gap-3">
    <Button as="a" :href="editRecipePath" class="gap-2">
      <Pencil :size="16" />
      Edit this recipe
    </Button>
    <form :action="recipePath" method="post">
      <input type="hidden" name="_method" value="delete" />
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <Button type="submit" variant="destructive" class="gap-2">
        <Trash2 :size="16" />
        Destroy this recipe
      </Button>
    </form>
    </div>
  </div>
</template>

<script setup>
import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-vue-next";

defineProps({
  currentUser: { type: Object, default: null },
  recipesPath: { type: String, required: true },
  editRecipePath: { type: String, required: true },
  recipePath: { type: String, required: true },
  csrfToken: { type: String, required: true },
});
</script>
